import React, { useState } from "react";
import "./style.css";

const modelImages = {
  "166YA": "https://aureusagro.pl/wp-content/uploads/2025/06/striegel-160good2-1.jpg",
  "160YA": "https://aureusagro.pl/wp-content/uploads/2025/06/striegel-160good2-1.jpg",
  "180YA": "https://aureusagro.pl/wp-content/uploads/2025/06/180ya.jpg",
  "195YA": "https://aureusagro.pl/wp-content/uploads/2021/04/195.png",
  "305YA": "https://aureusagro.pl/wp-content/uploads/2021/04/305ya.png",
  "505YA": "https://aureusagro.pl/wp-content/uploads/2021/04/505ya-1.png",
  "605YA": "https://aureusagro.pl/wp-content/uploads/2021/04/striegel605.jpg",
};

const modelDescriptions = {
  "166YA": "https://aureusagro.pl/striegel-160ya/",
  "160YA": "https://aureusagro.pl/striegel-160ya/",
  "180YA": "https://aureusagro.pl/striegel-180ya/",
  "195YA": "https://aureusagro.pl/striegel-195ya/",
  "305YA": "https://aureusagro.pl/striegel-305ya/",
  "505YA": "https://aureusagro.pl/striegel-505ya/",
  "605YA": "https://aureusagro.pl/striegel-605ya/",
};

const modelPrices = {
  "166YA": "95 200 zł netto",
  "160YA": "107 685 zł netto",
  "180YA": "124 710 zł netto",
  "195YA": "148 970 zł netto",
  "305YA": "154 444 zł netto",
  "505YA": "173 657 zł netto",
  "605YA": "199 620 zł netto",
};

const equipmentImages = {
  "Łyżka uniwersalna": "https://aureusagro.pl/wp-content/uploads/2025/06/1lyzka-uniwersalna.jpg",
  "Widło-krokodyl": "https://aureusagro.pl/wp-content/uploads/2025/06/1widlo-krokodyl.jpg",
  "Szuflo-Krokodyl": "https://aureusagro.pl/wp-content/uploads/2025/06/1-szuflo-krokodyl.jpg",
  "Łyżka wielofunkcyjna": "https://aureusagro.pl/wp-content/uploads/2025/06/1lyzka-wielofunkcyjna.jpg",
  "Chwytak do bel jednosiłownikowy": "https://aureusagro.pl/wp-content/uploads/2025/06/1chwytak.jpg",
  "Łyżka wielofunkcyjna 4w1": "https://aureusagro.pl/wp-content/uploads/2025/06/1lyzka-wielofunkcyjna.jpg",
  "Widły do palet": "https://aureusagro.pl/wp-content/uploads/2025/06/1widly.jpg",
  "Adapter Euro/Striegel": "https://aureusagro.pl/wp-content/uploads/2025/06/1adapter-euro.jpg",
  "Bez osprzętu": null
};

export default function FormularzStriegel() {
  const [model, setModel] = useState("160YA");
  const [kabina, setKabina] = useState(null);
  const [osprzet, setOsprzet] = useState([]);
  const [finansowanie, setFinansowanie] = useState(null);
  const [wariant, setWariant] = useState(null);
  const [kontakt, setKontakt] = useState({ imie: '', nazwisko: '', email: '', telefon: '' });
  const [obraz, setObraz] = useState(modelImages["160YA"]);
  const [wiadomosc, setWiadomosc] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [seconds, setSeconds] = useState(0);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = () => {
    if (!model || !kabina || !kontakt.imie || !kontakt.nazwisko || !kontakt.email || !kontakt.telefon) {
      setWiadomosc("Proszę wypełnić wszystkie pola.");
      return;
    }

    if (!validateEmail(kontakt.email)) {
      setWiadomosc("Podaj poprawny adres e-mail.");
      return;
    }

    setIsSending(true);
    setSeconds(0);

    const interval = setInterval(() => {
      setSeconds(prev => prev + 1);
    }, 1000);

    const dane = {
      model,
      kabina,
      osprzet: osprzet.join(", "),
      finansowanie,
      wariant,
      ...kontakt
    };

    fetch("https://aureusagro.pl/api/striegel_form.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dane)
    })
      .then(async res => {
        clearInterval(interval);
        const json = await res.json();

        if (res.ok) {
          window.location.href = "/oferta/potwierdzenie.html";
        } else {
          setWiadomosc("Błąd: " + (json.error || "Nieznany błąd"));
          setIsSending(false);
        }
      })
      .catch(() => {
        clearInterval(interval);
        setWiadomosc("Błąd połączenia z serwerem.");
        setIsSending(false);
      });
  };

  const handleModel = (value) => {
    setModel(value);
    setObraz(modelImages[value]);
  };

  const handleOsprzet = (value) => {
    let updated = osprzet.includes(value)
      ? osprzet.filter(o => o !== value)
      : [...osprzet, value];

    setOsprzet(updated);
    setObraz(value === "Bez osprzętu" ? modelImages[model] : equipmentImages[value]);
  };

  return (
    <>
      {/* 🔴 TOP BAR */}
      <div className="top-bar">
        Teraz limitowane fabryczne finansowanie, którego całkowity koszt to nawet +0,5% wartości maszyny.
      </div>

      <div className="container">
        <div className="form-section">

          <img
            src="https://www.ladowarkistriegel.pl/wp-content/uploads/brizy/imgs/logo-594x140x0x2x594x136x1618752091.png"
            alt="logo"
            className="logo"
          />

          <h2 className="title">Ładowarki Striegel</h2>

          {/* MODEL */}
          <h3 className="section-title">Model ładowarki</h3>
          <div className="grid">
            {Object.keys(modelImages).map((m) => (
              <button
                key={m}
                onClick={() => handleModel(m)}
                className={`button ${model === m ? "selected" : ""}`}
              >
                {m}
              </button>
            ))}
          </div>

          {/* KABINA */}
          <h3 className="section-title">Przeszklona kabina?</h3>
          <div className="grid">
            {["TAK", "NIE"].map((o) => (
              <button
                key={o}
                onClick={() => setKabina(o)}
                className={`button ${kabina === o ? "selected" : ""}`}
              >
                {o}
              </button>
            ))}
          </div>

          {/* OSPRZĘT */}
          <h3 className="section-title">Osprzęt</h3>
          <div className="grid">
            {Object.keys(equipmentImages).map((e) => (
              <button
                key={e}
                onClick={() => handleOsprzet(e)}
                className={`button ${osprzet.includes(e) ? "selected" : ""}`}
              >
                {e}
              </button>
            ))}
          </div>

          {/* FINANSOWANIE */}
          <h3 className="section-title">Finansowanie</h3>
          <div className="grid">
            {["Gotówka", "Finansowanie fabryczne"].map((f) => (
              <button
                key={f}
                onClick={() => {
                  setFinansowanie(f);
                  setWariant(null);
                }}
                className={`button ${finansowanie === f ? "selected" : ""}`}
              >
                {f}
              </button>
            ))}
          </div>

          {finansowanie === "Finansowanie fabryczne" && (
            <div className="finansowanie-box">
              <h4>💰 Dostępne warianty promocyjnego finansowania:</h4>

              {[
                "30% wpłaty | 36 miesięcy | koszt całkowity 100,5%",
                "20% wpłaty | 48 miesięcy | koszt całkowity 103,5%",
                "10% wpłaty | 60 miesięcy | koszt całkowity 107,5%",
              ].map((w) => (
                <button
                  key={w}
                  onClick={() => setWariant(w)}
                  className={`button ${wariant === w ? "selected" : ""}`}
                >
                  ✔ {w}
                </button>
              ))}

              <div className="finansowanie-info">
                ✔ raty miesięczne<br />
                ✔ stałe oprocentowanie
              </div>
            </div>
          )}

          {/* DANE */}
          <h3 className="section-title">Dane</h3>

          <input
            placeholder="Imię"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, imie: e.target.value })}
          />

          <input
            placeholder="Nazwisko"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, nazwisko: e.target.value })}
          />

          <input
            placeholder="Email"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, email: e.target.value })}
          />

          <input
            placeholder="Telefon"
            className="input"
            onChange={(e) => setKontakt({ ...kontakt, telefon: e.target.value })}
          />

          {/* PODSUMOWANIE */}
          <h3 className="section-title">Podsumowanie</h3>

          <p><strong>Model:</strong> {model}</p>
          <p><strong>Kabina:</strong> {kabina}</p>
          <p><strong>Finansowanie:</strong> {finansowanie}</p>

          {wariant && (
            <p><strong>Wariant:</strong> {wariant}</p>
          )}

          <button
            onClick={handleSubmit}
            className="submit"
            disabled={isSending}
          >
            {isSending ? `Wysyłam... (${seconds}s)` : "Zamawiam ofertę"}
          </button>

          <p className="submit-info">
            W godzinach pracy biura ofertę otrzymasz w ciągu 1h od wysłania zapytania
          </p>

          {wiadomosc && <div className="status-message">{wiadomosc}</div>}
        </div>

        {/* OBRAZ */}
        <div className="preview-section">
          <div className="image-wrapper">
  
  <div className="finance-badge">
    <span className="badge-small">Sprawdź!</span>
    <span className="price-highlight">
      Promocyjne<br />
      finansowanie<br />
      fabryczne!
    </span>
  </div>

  <img src={obraz} className="preview-image" />

  <div className="price-badge">
    <span className="badge-small">Cena katalogowa</span>
    <span className="price-highlight">{modelPrices[model]}</span>
  </div>

</div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-content">

          <p className="footer-main">
            Aureus Agro – Wyłączny dystrybutor niemieckich ładowarek przegubowych Striegel
          </p>

          <p>Fabryczna 3B, Andrychów, Poland, 34-120</p>
          <p className="footer-link">ladowarkistriegel.pl</p>

          <div className="footer-section">
            <strong>Siedziba główna Aureus Agro:</strong><br />
            +48 729 062 058 | kontakt@aureusagro.pl<br />
            Fabryczna 3B, 34-120 Andrychów
          </div>

          <div className="footer-section">
            <strong>Dział administracji i części zamiennych:</strong><br />
            +48 729 062 058<br />
            Jasnogórska 3 lok. B4, 44-100 Gliwice
          </div>

          <div className="footer-section">
            <strong>Plac pokazowy:</strong><br />
            Na Zakolu Wisły 6<br />
            30-729 Kraków
          </div>

        </div>
      </div>
    </>
  );
}